import React from "react";
import "./Ankerplatform.css";

class Ankerplatform extends React.Component {
  render() {
    return (
      <div className="ankerplatform">
        <div className="container">
          <div className="main-ankerplatform">
            <div className="left-ankerplatform">
              <div className="ankerplatform-title">
                <h2>
                  The <span> AnkerPlatform </span>
                  what makes it extraordinary.
                </h2>
                <p>
                  Designed to be the most functional blockchain with elements
                  that bring adoption with practical use-cases.
                </p>
              </div>
              <div className="ankerplatform-list">
                <span>AnkerChain features:</span>
                <ul>
                  <li>
                    One Click Node Setup &ensp;
                    <svg
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.792 10.6249C20.3207 10.153 19.5546 10.153 19.0834 10.6249L13.896 15.8117L11.7295 13.6457C11.2582 13.1739 10.4921 13.1739 10.0209 13.6457C9.54903 14.1176 9.54903 14.8825 10.0209 15.3543L13.0417 18.3751C13.2773 18.6114 13.5867 18.7292 13.896 18.7292C14.2053 18.7292 14.5147 18.6114 14.7503 18.3751L20.792 12.3335C21.2638 11.8616 21.2638 11.0967 20.792 10.6249Z"
                        fill="#01AAEC"
                      />
                      <path
                        d="M27.7917 13.2917C27.1247 13.2917 26.5833 13.833 26.5833 14.5C26.5833 21.1628 21.1628 26.5833 14.5 26.5833C7.83725 26.5833 2.41667 21.1628 2.41667 14.5C2.41667 7.83725 7.83725 2.41667 14.5 2.41667C17.7438 2.41667 20.7888 3.68421 23.0749 5.98608C23.5444 6.46035 24.3099 6.46277 24.7835 5.99213C25.2572 5.52208 25.2596 4.75721 24.7896 4.28354C22.0466 1.52129 18.392 0 14.5 0C6.50446 0 0 6.50446 0 14.5C0 22.4955 6.50446 29 14.5 29C22.4955 29 29 22.4955 29 14.5C29 13.833 28.4587 13.2917 27.7917 13.2917Z"
                        fill="#01AAEC"
                      />
                    </svg>
                  </li>
                  <li>
                    AnkerSavings&ensp;
                    <svg
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.792 10.6249C20.3207 10.153 19.5546 10.153 19.0834 10.6249L13.896 15.8117L11.7295 13.6457C11.2582 13.1739 10.4921 13.1739 10.0209 13.6457C9.54903 14.1176 9.54903 14.8825 10.0209 15.3543L13.0417 18.3751C13.2773 18.6114 13.5867 18.7292 13.896 18.7292C14.2053 18.7292 14.5147 18.6114 14.7503 18.3751L20.792 12.3335C21.2638 11.8616 21.2638 11.0967 20.792 10.6249Z"
                        fill="#01AAEC"
                      />
                      <path
                        d="M27.7917 13.2917C27.1247 13.2917 26.5833 13.833 26.5833 14.5C26.5833 21.1628 21.1628 26.5833 14.5 26.5833C7.83725 26.5833 2.41667 21.1628 2.41667 14.5C2.41667 7.83725 7.83725 2.41667 14.5 2.41667C17.7438 2.41667 20.7888 3.68421 23.0749 5.98608C23.5444 6.46035 24.3099 6.46277 24.7835 5.99213C25.2572 5.52208 25.2596 4.75721 24.7896 4.28354C22.0466 1.52129 18.392 0 14.5 0C6.50446 0 0 6.50446 0 14.5C0 22.4955 6.50446 29 14.5 29C22.4955 29 29 22.4955 29 14.5C29 13.833 28.4587 13.2917 27.7917 13.2917Z"
                        fill="#01AAEC"
                      />
                    </svg>
                  </li>
                  <li>
                    Anonymous Transactions&ensp;
                    <svg
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.792 10.6249C20.3207 10.153 19.5546 10.153 19.0834 10.6249L13.896 15.8117L11.7295 13.6457C11.2582 13.1739 10.4921 13.1739 10.0209 13.6457C9.54903 14.1176 9.54903 14.8825 10.0209 15.3543L13.0417 18.3751C13.2773 18.6114 13.5867 18.7292 13.896 18.7292C14.2053 18.7292 14.5147 18.6114 14.7503 18.3751L20.792 12.3335C21.2638 11.8616 21.2638 11.0967 20.792 10.6249Z"
                        fill="#01AAEC"
                      />
                      <path
                        d="M27.7917 13.2917C27.1247 13.2917 26.5833 13.833 26.5833 14.5C26.5833 21.1628 21.1628 26.5833 14.5 26.5833C7.83725 26.5833 2.41667 21.1628 2.41667 14.5C2.41667 7.83725 7.83725 2.41667 14.5 2.41667C17.7438 2.41667 20.7888 3.68421 23.0749 5.98608C23.5444 6.46035 24.3099 6.46277 24.7835 5.99213C25.2572 5.52208 25.2596 4.75721 24.7896 4.28354C22.0466 1.52129 18.392 0 14.5 0C6.50446 0 0 6.50446 0 14.5C0 22.4955 6.50446 29 14.5 29C22.4955 29 29 22.4955 29 14.5C29 13.833 28.4587 13.2917 27.7917 13.2917Z"
                        fill="#01AAEC"
                      />
                    </svg>
                  </li>
                  <li>
                    Transaction Surety&ensp;
                    <svg
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.792 10.6249C20.3207 10.153 19.5546 10.153 19.0834 10.6249L13.896 15.8117L11.7295 13.6457C11.2582 13.1739 10.4921 13.1739 10.0209 13.6457C9.54903 14.1176 9.54903 14.8825 10.0209 15.3543L13.0417 18.3751C13.2773 18.6114 13.5867 18.7292 13.896 18.7292C14.2053 18.7292 14.5147 18.6114 14.7503 18.3751L20.792 12.3335C21.2638 11.8616 21.2638 11.0967 20.792 10.6249Z"
                        fill="#01AAEC"
                      />
                      <path
                        d="M27.7917 13.2917C27.1247 13.2917 26.5833 13.833 26.5833 14.5C26.5833 21.1628 21.1628 26.5833 14.5 26.5833C7.83725 26.5833 2.41667 21.1628 2.41667 14.5C2.41667 7.83725 7.83725 2.41667 14.5 2.41667C17.7438 2.41667 20.7888 3.68421 23.0749 5.98608C23.5444 6.46035 24.3099 6.46277 24.7835 5.99213C25.2572 5.52208 25.2596 4.75721 24.7896 4.28354C22.0466 1.52129 18.392 0 14.5 0C6.50446 0 0 6.50446 0 14.5C0 22.4955 6.50446 29 14.5 29C22.4955 29 29 22.4955 29 14.5C29 13.833 28.4587 13.2917 27.7917 13.2917Z"
                        fill="#01AAEC"
                      />
                    </svg>
                  </li>
                  <li>
                    Intergrated Digital Identity&ensp;
                    <svg
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.792 10.6249C20.3207 10.153 19.5546 10.153 19.0834 10.6249L13.896 15.8117L11.7295 13.6457C11.2582 13.1739 10.4921 13.1739 10.0209 13.6457C9.54903 14.1176 9.54903 14.8825 10.0209 15.3543L13.0417 18.3751C13.2773 18.6114 13.5867 18.7292 13.896 18.7292C14.2053 18.7292 14.5147 18.6114 14.7503 18.3751L20.792 12.3335C21.2638 11.8616 21.2638 11.0967 20.792 10.6249Z"
                        fill="#01AAEC"
                      />
                      <path
                        d="M27.7917 13.2917C27.1247 13.2917 26.5833 13.833 26.5833 14.5C26.5833 21.1628 21.1628 26.5833 14.5 26.5833C7.83725 26.5833 2.41667 21.1628 2.41667 14.5C2.41667 7.83725 7.83725 2.41667 14.5 2.41667C17.7438 2.41667 20.7888 3.68421 23.0749 5.98608C23.5444 6.46035 24.3099 6.46277 24.7835 5.99213C25.2572 5.52208 25.2596 4.75721 24.7896 4.28354C22.0466 1.52129 18.392 0 14.5 0C6.50446 0 0 6.50446 0 14.5C0 22.4955 6.50446 29 14.5 29C22.4955 29 29 22.4955 29 14.5C29 13.833 28.4587 13.2917 27.7917 13.2917Z"
                        fill="#01AAEC"
                      />
                    </svg>
                  </li>
                  <li>
                    Community Driven&ensp;
                    <svg
                      width="29"
                      height="29"
                      viewBox="0 0 29 29"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20.792 10.6249C20.3207 10.153 19.5546 10.153 19.0834 10.6249L13.896 15.8117L11.7295 13.6457C11.2582 13.1739 10.4921 13.1739 10.0209 13.6457C9.54903 14.1176 9.54903 14.8825 10.0209 15.3543L13.0417 18.3751C13.2773 18.6114 13.5867 18.7292 13.896 18.7292C14.2053 18.7292 14.5147 18.6114 14.7503 18.3751L20.792 12.3335C21.2638 11.8616 21.2638 11.0967 20.792 10.6249Z"
                        fill="#01AAEC"
                      />
                      <path
                        d="M27.7917 13.2917C27.1247 13.2917 26.5833 13.833 26.5833 14.5C26.5833 21.1628 21.1628 26.5833 14.5 26.5833C7.83725 26.5833 2.41667 21.1628 2.41667 14.5C2.41667 7.83725 7.83725 2.41667 14.5 2.41667C17.7438 2.41667 20.7888 3.68421 23.0749 5.98608C23.5444 6.46035 24.3099 6.46277 24.7835 5.99213C25.2572 5.52208 25.2596 4.75721 24.7896 4.28354C22.0466 1.52129 18.392 0 14.5 0C6.50446 0 0 6.50446 0 14.5C0 22.4955 6.50446 29 14.5 29C22.4955 29 29 22.4955 29 14.5C29 13.833 28.4587 13.2917 27.7917 13.2917Z"
                        fill="#01AAEC"
                      />
                    </svg>
                  </li>
                </ul>
              </div>
            </div>
            <div className="right-ankerplatform">
              <div className="block">
                <div className="nodes">
                  <div>5</div>
                  <span>NODES ONLINE</span>
                </div>
                <div className="heights">
                  <div>2,982</div>
                  <span>BLOCK HEIGHT</span>
                </div>
                <div className="downloads">
                  <div>8,479</div>
                  <span>WALLET DOWNLOADS</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Ankerplatform;
